import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

import RightArrow from '../../assets/images/right-arrow.png';

export default function PreDevelopmentPlanningServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Pre-Development Planning</title>
        <meta
          name='description'
          content='We lay the groundwork for success through deep feasibility analysis, entitlement strategy, and municipal coordination. Our goal is to remove uncertainty early and position each project for strong returns and smooth approvals.'
        />
        <meta
          name='keywords'
          content='Starlife, Pre-Development Planning, feasibility analysis, entitlement strategy, municipal coordination, project approvals'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>Pre-Development Planning</h2>
        <p className='service-page-text'>
          We lay the groundwork for success through deep feasibility analysis,
          entitlement strategy, and municipal coordination. Our goal is to
          remove uncertainty early and position each project for strong returns
          and smooth approvals.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Other Services</h2>
        <div className='service-list'>
          <Link
            to={ROUTE_NAMES.REALESTATEDEVELOPMENT}
            className='service-block'
          >
            <h3>Real Estate Development & Strategic Acquisitions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.DESIGNBUILD}
            className='service-block green-block'
          >
            <h3>Design-Build & Construction Management</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link to={ROUTE_NAMES.SMARTSUSTAINABLE} className='service-block'>
            <h3>Smart & Sustainable Building Solutions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
